const React = require('react');
const T = require('prop-types');
const { default: FlatButton } = require('@mui/material/Button');
const { default: Classes } = require('./styles.scss');
const Fonts = require('styles/fonts.json');
const Colors = require('styles/colors.json');
const { analyticsTemplates } = require('utils/analytics');
const { useEffect } = require('react');
const Logomark = require('static/nearpeer_n_white.svg');
const NearpeerMobile = require('static/nearpeer-mobile.png');
const Login = require('routes/login/containers/Login');

// iOS-only image is for app store compliance.
// Keeping this comment as a reminder if we change the image later.
// iOS app store won't allow any images of an Android phone.
const NearpeerMobileiOS = NearpeerMobile;
const PlayStore = require('static/google_play.svg');
const AppStore = require('static/app_store.svg');
const ScrollContainerLayout = require('layouts/ScrollContainerLayout');
const Footer = require('components/Footer');
const NearpeerMobileBusinessiOS = require('static/nearpeer-mobile-business-ios-new.png');
const NearpeerMobileBusiness = require('static/nearpeer-mobile-business-no-bg.png');
const { default: Styled } = require('styled-components');
const Snackbar = require('containers/Snackbar');
const { getDevice, isIOS, isUnknown } = require('utils/device');
const DowntimeDialog = require('containers/DowntimeDialog');
const ForceAppUpgradeDialog = require('containers/ForceAppUpgradeDialog');
const RoutingTable = require('services/auth-management/routing-table');

const { useAppSelector } = require('utils/redux');

const { context } = require('app-context');

const { selectors: { all: selectors } } = context;

const internals = {};

const Home = (props) => {

    const {
        isAuthenticated = false,
        onLogout = () => null,
        push,
        location
    } = props;

    const {
        Wrapper,
        StyledButton
    } = internals;

    useEffect(() => {

        if (isAuthenticated) {
            push(RoutingTable.getAppLoaderRoute());
        }
    }, [isAuthenticated, push]);

    const isTeamsApp = process.env.APP_FLAVOUR === 'teams';

    const device = getDevice();

    const logout = () => {

        analyticsTemplates.buttons('logout', 'landing page: logout');
        return onLogout();
    };

    return <Wrapper>
        <ScrollContainerLayout>
            <div className={Classes.bodyContainer}>

                <div className={Classes.homeMain} role='main'>

                    <div className={Classes.logoContainer}>
                        <div className={Classes.logomarkContainer}>
                            <img src={Logomark} alt='' className={Classes.logomark} />
                            <div className={Classes.tm}>™</div>
                        </div>
                        <h1
                            id='main-page-heading'
                            tabIndex={0}
                            className={Classes.header}
                        >
                            Nearpeer
                        </h1>
                    </div>

                    <div className={Classes.subtitle}>{'Life is better when you\'re part of the community'}</div>

                    <div className={Classes.homeContent}>
                        <div className={Classes.mobileScreensContainer}>
                            <img
                                className={Classes.mobileScreens}
                                src={isTeamsApp ? (isIOS(device) ? NearpeerMobileBusinessiOS : NearpeerMobileBusiness) : (isIOS(device) ? NearpeerMobileiOS : NearpeerMobile)}
                                alt='Nearpeer screenshots on Android and iOS'
                            />
                        </div>
                        <div className={Classes.homeActions}>
                            {!window.cordova && <div className={Classes.getApps}>
                                <div className={Classes.actionText}>For the best experience, get the Nearpeer app today!</div>
                                {
                                    // Only show Play Store link on Android devices, and only App Store link on iOS devices.
                                    // Also, incorporate a slight style change if only one button is shown (Classes.onPhone)
                                }
                                <div className={`${Classes.getAppsButtons} ${!isUnknown(device) && Classes.onPhone}`}>
                                    {(
                                        isTeamsApp ? <a
                                            onClick={() => analyticsTemplates.buttons('landing page', 'landing page: get ios app')}
                                            className={Classes.getAppsButton}
                                            href="https://itunes.apple.com/us/app/nearpeer-for-teams/id6445984458"
                                            rel="noreferrer"
                                            target={'_blank'}
                                            data-focus-outline='radius:5,padding:2'
                                        >
                                            <img src={AppStore} alt="AppStore" />
                                        </a> : <a
                                            onClick={() => analyticsTemplates.buttons('landing page', 'landing page: get ios app')}
                                            className={Classes.getAppsButton}
                                            href="https://itunes.apple.com/us/app/nearpeer-for-college-students/id1300243604"
                                            rel="noreferrer"
                                            target={'_blank'}
                                            data-focus-outline='radius:5,padding:2'
                                        >
                                            <img src={AppStore} alt="AppStore" />
                                        </a>
                                    )}
                                    {(
                                        isTeamsApp  ? <a
                                            onClick={() => analyticsTemplates.buttons('landing page', 'landing page: get android app')}
                                            className={Classes.getAppsButton}
                                            href="https://play.google.com/store/apps/details?id=net.nearpeer.app_business"
                                            rel="noreferrer"
                                            target={'_blank'}
                                            data-focus-outline='radius:5,padding:2'
                                        >
                                            <img src={PlayStore} alt="PlayStore" />
                                        </a> : <a
                                            onClick={() => analyticsTemplates.buttons('landing page', 'landing page: get android app')}
                                            className={Classes.getAppsButton}
                                            href="https://play.google.com/store/apps/details?id=net.nearpeer.app"
                                            rel="noreferrer"
                                            target={'_blank'}
                                            data-focus-outline='radius:5,padding:2'
                                        >
                                            <img src={PlayStore} alt="PlayStore" />
                                        </a>
                                    )}
                                </div>
                            </div>}
                            <div className={Classes.signupContainer}>
                                {isAuthenticated ? (
                                    <StyledButton
                                        onClick={logout}
                                        color={'primary'}
                                        data-focus-outline='radius:40,padding:4'
                                    >
                                        Log Out
                                    </StyledButton>
                                ) : (
                                    <div className={Classes.loginFormContainer}>
                                        <div className={Classes.actionText}>Log into Nearpeer:</div>
                                        <Login embedded location={location} />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
                <Snackbar />
                <DowntimeDialog />
                <ForceAppUpgradeDialog />
            </div>
        </ScrollContainerLayout>
    </Wrapper>;
};

Home.propTypes = {
    isAuthenticated: T.bool.isRequired,
    onLogout: T.func.isRequired,
    push: T.func.isRequired,
    location: T.object
};

module.exports = Home;

internals.Wrapper = Styled.div`
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
`;

internals.StyledButton = Styled(FlatButton)({
    backgroundColor: Colors.lightText,
    marginBottom: '15px',
    height: '3em',
    width: '100%',
    '&:hover': {
        backgroundColor: Colors.lightText
    },
    fontFamily: Fonts.headerFont,
    fontWeight: 'bold',
    textTransform: 'none',
    fontSize: '1em',
    letterSpacing: 1,
    lineHeight: '3em'
});
